import { useState, FormEvent } from "react";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setStatus("success");
      setMessage("订阅成功！感谢您的关注。");
      form.reset();
      return;
    }

    setStatus("loading");
    setMessage("");
    setStatus("success");
    setMessage("订阅成功！感谢您的关注。");
    form.reset();
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-primary-500">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50">
          订阅我们的更新通知
        </h2>
        <p className="mt-3 text-sm md:text-base text-background-50/80">
          第一时间获取最新漫画更新、精选推荐和独家活动信息
        </p>

        <form
          onSubmit={handleSubmit}
          className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            required
            placeholder="输入你的邮箱地址"
            className="flex-1 px-5 py-3 rounded-full text-sm bg-background-50 text-foreground-950 placeholder:text-foreground-400 border-2 border-transparent focus:border-background-50 focus:outline-none transition-colors"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-anti-spam"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="px-7 py-3 rounded-full text-sm font-semibold bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60"
          >
            {status === "loading" ? "提交中..." : "立即订阅"}
          </button>
        </form>

        {message && (
          <p
            className={`mt-4 text-sm ${
              status === "success" ? "text-background-50" : "text-background-50/90"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}
